import { render, staticRenderFns } from "./PanelDayPrice.vue?vue&type=template&id=1fa467fa&scoped=true"
import script from "./PanelDayPrice.vue?vue&type=script&lang=js"
export * from "./PanelDayPrice.vue?vue&type=script&lang=js"
import style0 from "./PanelDayPrice.vue?vue&type=style&index=0&id=1fa467fa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa467fa",
  null
  
)

export default component.exports